import { education, languages, skillGroups } from '../../data/siteContent';
import { useApp } from '../../context/AppContext';
import { Reveal } from '../ui/Reveal';
import { SectionHeading } from '../ui/SectionHeading';

// Skills turns a standard technology list into an editorial capability matrix.
export function Skills() {
  const { language, t } = useApp();

  return (
    <section className="skills-section section-pad">
      <div className="page-shell">
        <SectionHeading kicker={t.skills.kicker} title={t.skills.title} />

        <div className="skills-grid">
          {skillGroups.map((group, index) => {
            const Icon = group.icon;
            return (
              <Reveal className="skill-card" delay={index * 0.06} key={group.key}>
                <div className="skill-card__head">
                  <span>0{index + 1}</span><Icon strokeWidth={1.5} />
                </div>
                <h3>{t.skills[group.key]}</h3>
                <ul>
                  {group.skills.map((skill) => <li key={skill}>{skill}</li>)}
                </ul>
              </Reveal>
            );
          })}
        </div>

        <div className="credentials-grid">
          <Reveal className="credentials-panel">
            <p className="eyebrow">{t.skills.education}</p>
            {education.map((item) => {
              const Icon = item.icon;
              return (
                <article className="education-item" key={item.year}>
                  <Icon />
                  <div><h3>{item.title[language]}</h3><p>{item.place} · {item.year}</p></div>
                </article>
              );
            })}
          </Reveal>

          <Reveal className="credentials-panel" delay={0.08}>
            <p className="eyebrow">{t.skills.languages}</p>
            <div className="language-levels">
              {languages.map((item) => (
                <div className="language-level" key={item.label.en}>
                  <div><span>{item.label[language]}</span><small>{item.level}%</small></div>
                  <span><i style={{ width: `${item.level}%` }} /></span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
